import Popup from '../helpers/Popup';
import moment from 'moment';

;$(function() {
  function getTableData(cityID) {
    $.ajax({
      type: 'post',
      url: '/api/balance/city',
      data: {city: cityID},
      success: r => {
        const data = JSON.parse(r)
        const tableData = data.data
        $('.balance-table > tbody').empty()
        for (const item of tableData) {
          const opearation = ''
          const change = ''
          const button = ''
          const date = ''
          const startingTime = '<td></td>'
          
          //Таймер
          if (item.type === 'FINE' && item.fine_status === true) {
            startingTime = `<td><span class="table-countdown">${item.datetime}</span></td>`
          }

          //условия для текста операции
          if (item.type === 'FINE') {
            opearation = '<td>Списание</td>'
          } else if (item.type === 'CHALLENGE') {
            opearation = '<td>Оспаривание</td>'
          } else if (item.type === 'PAYMENT') {
            opearation = '<td>Пополнение</td>'
          }

          //условия для цвета изменения
          if (item.type === 'PAYMENT') {
            if (item.challenge_status === 1) {
              change = '<td class="plus">Внесение ОП</td>'
            }
            if (item.challenge_status === 2) {
              change = '<td class="minus">Наложен штраф</td>'
            }
            if (item.challenge_status === 3) {
              change = '<td class="plus">Вовзрат ОП</td>'
            }
          } else if (item.btn_class === 'minus') {
            change = '<td class="minus">Наложен штраф</td>'
          } else if (item.btn_class === 'plus') {
            change = '<td class="plus">Штраф аннулирован</td>'
          } else {
            change = '<td>В процессе</td>'
          }
          

          //условия для даты
          if (item.type === 'PAYMENT') {
            date = item.added_at || item.finished_at
          }

          //условия для кнопок
          if (item.type === 'FINE' && item.fine_status === true) {
            button = '<td><div class="balance-table__btn red">Оспорить</div></td>'
          } else if (item.type === 'FINE' && item.fine_status === false) {
            button = '<td><div class="balance-table__btn grey">Оспорить</div></td>'
          } else if (item.type === 'PAYMENT') {
            button = '<td></td>'
          } else if (item.type === 'CHALLENGE' && item.challenge_status === 2) {
            button = '<td><div class="balance-table__btn approved"><span>Оспорено</span><img src="/static/images/approve.svg" alt=""></div></td>'
          } else if (item.type === 'CHALLENGE' && item.challenge_status === 1) {
            button = '<td><div class="balance-table__btn question"><span>Заявка на оспаривание</span><img src="/static/images/question.svg" alt=""></div></td>'
          } else {
            button = '<td><div class="balance-table__btn declined"><span>Отказ в оспаривании</span><img src="/static/images/decline.svg" alt=""></div></td>'
          }

          $('.balance-table > tbody:last-child').append(`<tr>${ opearation } ${ change } <td class="lot-id">${ item.lot_id }</td> ${ startingTime } <td>${ date }</td>  ${ button } </tr>`)
        }

        initTimer()

      },
      error: e => {
        console.log(e)
      }
    })
  }

  $( document ).ready(function() {
    getTableData(1, $('.balance__count'), $('.balance__auction'))
  })

  $('.balance__city').click(function() {
    const city = $(this)

    if (city.hasClass('active')) {
      return
    }

    const parent = city.parents('.balance')
    const balance = parent.find('.balance__count')
    const auction = parent.find('.balance__auction')
    const cityID = city.attr('data-city')
    getTableData(cityID, balance, auction)
    parent.find('.balance__city.active').removeClass('active')
    city.addClass('active')
  })

  $('.balance__btn.balance__btn_red').click(function() {
    const currentCity = $('.balance__city.active').attr('data-city')
    $.ajax({
      method: 'post',
      url: '/api/form/topup',
      data: {
        cityId: currentCity,
      },
      success: r => {
        const data = JSON.parse(r)
        if (data.OBJECT === 'PAYMENT' && data.TYPE === 'GET_PAY_LINK') {
          $('.balance-popup__text').html('Для пополнения баланса перейдите по ссылке.')
          $('.balance-popup__btn').remove()
          $('.balance-popup').append(`<a href="${data.DATA.LINK}" target="_blank" class="balance-popup__btn">Оплатить</a>`)
          Popup.show('#popup-balance')
        } else {
          $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
          Popup.show('#popup-balance')
        }
      },
      error: e => {
        $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
        Popup.show('#popup-balance')
      }
    })
  })

  $('.balance__btn.balance__btn_grey').click(function() {
    const currentCity = $('.balance__city.active').attr('data-city')
    $.ajax({
      method: 'post',
      url: '/api/form/withdraw',
      data: {
        cityId: currentCity,
      },
      success: r => {
        const data = JSON.parse(r)
        $('.balance-popup__btn').remove()
        if (data.STATUS === 'OK') {
          $('.balance-popup__text').html('Ваша заявка принята.')
          Popup.show('#popup-balance')
        } else {
          $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
          Popup.show('#popup-balance')
        }
      },
      error: e => {
        console.log(e)
        $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
        Popup.show('#popup-balance')
      }
    })
  })

  $('.balance-table').on('click', '.balance-table__btn.red', function() {
    const currentCity = $('.balance__city.active').attr('data-city')
    const parent = $(this).parents('tr').eq(0)
    const lotId = parent.find('.lot-id').html()
    Popup.show('#popup-challenge')
    $('.challenge-popup__btn').click(function() {
      const msg = $('.challenge-popup__textarea').val()
      $.ajax({
        method: 'post',
        url: '/api/form/challenge',
        data: {
          cityId: currentCity,
          lotId: lotId,
          msg: msg
        },
        success: r => {
          Popup.close('#popup-challenge')
          const data = JSON.parse(r)
          $('.balance-popup__btn').remove()
          if (data.STATUS === 'OK') {
            $('.balance-popup__text').html('Ваша заявка принята.')
            Popup.show('#popup-balance')
          } else {
            $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
            Popup.show('#popup-balance')
          }
        },
        error: e => {
          Popup.close('#popup-challenge')
          $('.balance-popup__text').html('К сожалению, произошла ошибка. Попробуйте позже или свяжитесь с нами по номеру <a href="tel:88005557525">8 (800) 555-75-25</a>')
          Popup.show('#popup-balance')
        }
      })
    })
  })

  $('.low-balance-popup__btn_red, .low-balance-popup__btn_grey').click(function() {
    Popup.close('#popup-low-balance')
  })

  function timerHandler(item) {
    const curentDate = item.html()
    const timestamp = moment(curentDate, 'DD.MM.YYYY HH:mm:ss').valueOf() / 1000;
    const targetDate = moment.unix(timestamp).add(3, 'days');
    
    function updateCountdown() {
      let now = moment();
      let diff = moment.duration(targetDate.diff(now));
      let days = diff.days();
      let hours = (diff.hours() + (days*24)).toString().padStart(2, '0');
      let minutes = diff.minutes().toString().padStart(2, '0');
      let seconds = diff.seconds().toString().padStart(2, '0');
      
      item.text('Осталось: ' + hours + ':' + minutes + ':' + seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  function initTimer() {
    const items = $('.table-countdown').each(function(idx){this.id=idx})
    items.each(function() {
      timerHandler($(this))
    })
  }
})